import React, { memo } from 'react'
import { oneOfType, number, string } from 'prop-types'

export const Search = memo(({ height = '100%', width = '100%', strokeColor = 'white' }) => {
	return (
		<svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 27.2 30.6"
			style={{ enableBackground: 'new 0 0 27.2 30.6' }}
			xmlSpace="preserve"
		>
			<path
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeMiterlimit={10}
				d="M9.7,19c-4.4-3.5-5-9.9-1.5-14.2c3.5-4.4,9.9-5,14.2-1.5c4.4,3.5,5,9.9,1.5,14.2S14,22.5,9.7,19z"
			/>
			<line
				fill="none"
				stroke={strokeColor}
				strokeWidth={2.1}
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit={10}
				x1="9.5"
				y1="19.2"
				x2="1"
				y2="29.5"
			/>
		</svg>
	)
})

Search.propTypes = {
	strokeColor: string,
	height: oneOfType([number, string]),
	width: oneOfType([number, string]),
}
